<template>
  <div class="moow-master-container">
    <!-- <nav-default></nav-default> -->
    <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <b-container class="dashboard-container">
      <b-row>
        <b-col xl="1" lg="1" md="0" />
        <b-col xl="10" lg="10" md="12" class="m-0 p-0">
          <div class="help-action-btn reload-items">
            <md-button
              @click="reloadDashboardItems"
              class="md-icon-button md-raised"
              :disabled="loadingDeals"
            >
              <div
                v-if="loadingDeals"
                class="loader-rolling-local_white"
                style="color:white"
              ></div>
              <md-icon v-else>cached</md-icon>
            </md-button>
          </div>
          <div @click="showHelpDialog('bookingStatus')" class="help-action-btn help-dialog">
            <md-button class="md-fab md-dense play-cta-fab_flat">
              <md-icon>help_outline</md-icon>
            </md-button>
          </div>
          <md-tabs
            md-sync-route
            :md-active-tab="activeTab"
            id="mo-accent"
            style="width: 100%;max-width:100vw;"
            @md-changed="changedTab"
            class="md-primary play-tabs dark"
            md-elevation="5"
          >
            <md-tab id="tab-active" md-label="Deals">
              <deal-previews
                ref="dealPreviewsRef"
                @emitCheckCurrUserValidity="currentUserDataIsSufficeForContracts"
                @emitStartNewDeal="startNewDeal"
                @emitGoForward="goForward"
              ></deal-previews>
            </md-tab>
          </md-tabs>
        </b-col>
        <b-col xl="1" lg="1" md="0" />
      </b-row>
    </b-container>
  </div>
</template>
<script>
import DealPreviews from "../../components/dashboard/dealPreviews.vue";
import { getCurrentUser } from "../../users/services/userService.js";
import { getCurrentFirebaseUser } from "@/platform/auth/services/authService.js";

export default {
  props: {
    activeTabOverwrite: {
      type: String,
      required: false
    },
    reload: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    'deal-previews': DealPreviews
  },
  data() {
    return {
      loading: true,
      reloadingDasboardItems: false,
      activeTab: "tab-active",
      currentUserIdCode: ""
    };
  },
  computed: {
    loadingDeals() {
      return this.$store.getters.loadingDeals;
    },
    placeholder() {
      return require("../../assets/placeholder.png");
    },
    refreshIcon() {
      return require("../../assets/refresh.svg");
    },
    loaderRolling() {
      return required("../../assets/loader-rolling.svg");
    }
  },
  async created() {
    let user = getCurrentFirebaseUser()
    console.log("Deals | created > user: ", user.displayName)
    if (user && !user.isAnonymous) {
      this.accountHolderNamePlaceholder = "Ex. " + user.displayName;
      this.userUid = user.uid;
      this.loading = true
      const cUser = await getCurrentUser(user.uid)
      if(!cUser) this.loading = false
      else {
        this.loading = false
        this.currentUserIdCode = cUser.idCode;
      }
    }
    if (this.activeTabOverwrite) this.activeTab = this.activeTabOverwrite;
    if (this.reload) this.reloadDashboardItems();
  },
  updated() {},
  methods: {
    goForward({where, params}){
      this.$emit("emitGoForward", {
        where: where,
        params: params
      })
    },
    showHelpDialog(whatAbout) {
      var title = "";
      var message = "";
      if (whatAbout == "bookingStatus") {
        title = "All bookings, contracts and other Deals are here";
        message =
        "You can create a deal manually (import) or they will appead here automatically, when tenant is interested in Your listing. To add a new deal manually, go to Properties and click on Manage button on a specific property";
      }
      this.$emit("emitToggleHelpDialog", { title, message });
    },
    startNewDeal() {
      this.redirectTo("dealApplicationProperty");
    },
    currentUserDataIsSufficeForContracts() {
      if (!this.currentUserIdCode || this.currentUserIdCode == "") {
        this.$notify({
          title: "Specify ID Code",
          message: "Personal identification code is required for contracts."
        });
        this.redirectTo("account", {
          openWithTab: "tab-identity",
          postSaveRedirect: "bookings"
        });
      }
    },
    redirectTo(where, params) {
      this.$router.push({
        name: where,
        params: params
      });
    },
    changedTab(tabId) {
      this.activeTab = tabId;
    },
    updateReloadingDasboardItems(status) {
      this.reloadingDasboardItems = status;
    },
    reloadDashboardItems() {
       if (this.$refs.dealPreviewsRef) this.$refs.dealPreviewsRef.reload();
    },
    notifyError(title, msg) {
      this.$notify({
        title: title,
        message: msg
      });
    },
    viewBooking(bookingId) {
      if (!bookingId)
        this.notifyError(
          "Something is not right",
          "cannot redirect to booking automatically"
        );
      this.$router.push({
        name: "booking",
        params: {
          bookingId: bookingId
        }
      });
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/dashboard.css";
@import "../../assets/styles/global.css";
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Deals.vue